
export enum StatusDocument {
  APPROVED = 'APROVADO',
  EXCUSED = 'JUSTIFICADO',
  PENDING = 'PENDENTE',
  REJECTED = 'REJEITADO',
  REMOVED = 'REMOVIDO',
  SENT = 'ENVIADO',
}
